/** Shared feature cards for Studio home and InterviewFlow dashboard. */
export const STUDIO_FEATURE_HIGHLIGHTS = [
  {
    id: 'studio',
    title: 'Studio',
    description: 'Build flows, apps, and forms — turn real processes into something your team can run.',
    path: '/studio',
    icon: 'hub',
    tone: 'primary',
  },
  {
    id: 'templates',
    title: 'Starter templates',
    description: 'Recruiting bundles, screening + scorecard pilots, and vertical app shells.',
    path: '/studio/templates',
    icon: 'star',
    tone: 'secondary',
  },
  {
    id: 'extensions',
    title: 'Extensions & tools',
    description: 'InterviewFlow skills, MCP tools, Clio legal nodes, and the unified tool catalog.',
    path: '/studio/extensions',
    icon: 'extension',
    tone: 'info',
  },
  {
    id: 'help',
    title: 'Studio Help',
    description: 'Architecture diagrams, use-case guides, debug tips, and troubleshooting.',
    path: '/studio/help/overview',
    icon: 'help',
    tone: 'success',
  },
  {
    id: 'mcp',
    title: 'AI assistants',
    description: 'Connect Cursor, Claude Code and other MCP clients to your published flows.',
    path: '/studio/connect',
    icon: 'code',
    tone: 'warning',
  },
  {
    id: 'recruiting',
    title: 'Recruiting playbooks',
    description: 'Structured screening (#1) and post-interview scorecard (#3) walkthroughs.',
    path: '/studio/help/recruiting',
    icon: 'work',
    tone: 'primary',
  },
  {
    id: 'permits',
    title: 'CLAW · SF advisor',
    description: 'Client demo: skill if-sf-application-advisor, parcel + advise capabilities, agent tool loop in a Studio App.',
    path: '/studio/help/permits',
    icon: 'map',
    tone: 'info',
  },
];
